import React, { useEffect, useState, useRef, useMemo } from "react";
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import ToggleButton from "react-bootstrap/ToggleButton";
import Badge from "react-bootstrap/Badge";
import Container from "react-bootstrap/Container";
import Accordion from "react-bootstrap/Accordion";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Dropdown from "react-bootstrap/Dropdown";

import "./agentAssist.css";
import { generateUniqueID } from "../../utility/util";
import { useAppConfig } from "../../providers/AppConfigProvider";
import useAgentAssistApi from "../../hooks/useAgentAssistApi";
import CopyToClipboard from "../CustomRag/CopyToClipboard";
import Feedback from "../CustomRag/Feedback";

function CustomToggle({ children, eventKey }) {
  const decoratedOnClick = useAccordionButton(eventKey, () =>
    console.log("totally custom!")
  );

  return (
    <strong
      style={{
        color: "#545b64",
        fontSize: "14px",
        fontFamily: "Amazon Ember, Helvetica, sans-serif",
      }}
      onClick={decoratedOnClick}
    >
      {children}
      <i className="fa-solid fa-angle-down arrow-down"></i>
    </strong>
  );
}

const ResponseSection = ({
  response,
  index,
  user,
  submittedFeedBackId,
  setSubmittedFeedBackId,
  submitFeedback,
}) => {
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const THUMBS_DOWN_REASONS = [
    "Not responsive",
    "Slow response time",
    "Off-topic responses",
    "Too lengthy",
    "Lack of detail",
    "Repetitive information",
  ];
  const [extraComments, setExtraComments] = useState("");
  const [feedbackSelected, setFeedbackSelected] = useState([]);

  const storeFeedback = (reason) => {
    console.log("[reason]", reason);
    if (feedbackSelected.includes(reason)) {
      setFeedbackSelected(feedbackSelected.filter((item) => item !== reason));
    } else {
      setFeedbackSelected([...feedbackSelected, reason]);
    }
  };

  // useEffect(() => {
  //   console.log("reason feedbackSelected", feedbackSelected);
  // }, [feedbackSelected]);

  const submitVoteDown = async () => {
    try {
      await submitFeedback({
        event: "IS_VOTE_DOWN",
        user,
        qid: response.qid,
        updateValue: -1,
        reason: feedbackSelected,
        comments: extraComments === "" ? null : extraComments,
      });
      setSubmittedFeedBackId({
        ...submittedFeedBackId,
        [`${response.query}-${response.qid}-${user}`]: -1,
      });
    } catch (error) {
      console.log("[error]", error);
    } finally {
      setExtraComments("");
      setFeedbackSelected([]);
      setShowFeedbackModal(false);
    }
  };

  const submitVoteUp = async () => {
    try {
      await submitFeedback({
        event: "IS_VOTE_UP",
        user,
        qid: response.qid,
        updateValue: 1,
      });
      setSubmittedFeedBackId({
        ...submittedFeedBackId,
        [`${response.query}-${response.qid}-${user}`]: 1,
      });
    } catch (error) {
      console.log("[error]", error);
    }
  };

  const submitIsCopied = async () => {
    try {
      submitFeedback({
        event: "IS_COPIED",
        user,
        qid: response.qid,
        isCopied: true,
      });
    } catch (error) {
      console.log("[error]", error);
    }
  };

  return (
    <Container key={index} fluid className={`contact-details mb-2 mt-2 px-1`}>
      <div
        className="card custom-card p-3 rounded-0"
        style={{ fontSize: "12px" }}
      >
        <div>
          <i className="fa-regular fa-user m-0"></i>
          <span className="ms-2">{response.name} said:</span>
          <p className="fw-bold mb-0 mt-1">{`"${response.query}"`}</p>
        </div>
        <hr className="mt-3 mb-3" />
        <Accordion defaultActiveKey={["0"]} alwaysOpen>
          <CustomToggle eventKey="0">
            <span className="cursor-pointer">Response</span>
          </CustomToggle>
          <Accordion.Collapse eventKey="0">
            <>
              <div className="d-flex align-items-center justify-content-end mb-3">
                <div className="icons d-flex align-items-center">
                  <CopyToClipboard
                    text={response?.answer}
                    initialContactId={user}
                    qid={response.qid}
                    isCopied={true}
                    submitIsCopied={submitIsCopied}
                  />

                  <div className="feedback-icons">
                    <div className="line"></div>
                    <i
                      className={`fa-solid fa-thumbs-up cursor-pointer ${
                        submittedFeedBackId[
                          `${response.query}-${response.qid}-${user}`
                        ] === 1
                          ? "text-success"
                          : ""
                      }`}
                      onClick={() => {
                        submitVoteUp();
                      }}
                    ></i>
                    <i
                      className={`fa-solid fa-thumbs-down ms-1 cursor-pointer ${
                        submittedFeedBackId[
                          `${response.query}-${response.qid}-${user}`
                        ] === -1
                          ? "text-success"
                          : ""
                      }`}
                      onClick={() => {
                        setShowFeedbackModal(true);
                      }}
                    ></i>
                  </div>
                  <Modal
                    size="sm"
                    show={showFeedbackModal}
                    onHide={() => {
                      setShowFeedbackModal(false);
                    }}
                    centered
                  >
                    <Modal.Header closeButton>
                      <div className="fs-5">Feedback Modal</div>
                    </Modal.Header>
                    <Modal.Body>
                      {THUMBS_DOWN_REASONS.map((reason, index) => {
                        return (
                          <Form.Check // prettier-ignore
                            key={index}
                            className="fs-14"
                            type={"checkbox"}
                            id={reason}
                            label={reason}
                            onChange={() => {
                              storeFeedback(reason);
                            }}
                            value={feedbackSelected.includes(reason)}
                          />
                        );
                      })}
                      <div className="input-group-sm w-100">
                        <textarea
                          rows="1"
                          value={extraComments}
                          onChange={(e) => {
                            setExtraComments(e.target.value);
                          }}
                          type="text"
                          className="form-control"
                        ></textarea>
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        size="sm"
                        type="button"
                        variant="primary"
                        disabled={feedbackSelected.length <= 0}
                        onClick={() => {
                          submitVoteDown();
                        }}
                      >
                        Submit
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </div>
              </div>
              <p>{response?.answer}</p>
            </>
          </Accordion.Collapse>
          <hr className="mt-3 mb-3" />
          <CustomToggle eventKey="1">
            <span className="cursor-pointer">Citation</span>
          </CustomToggle>
          <Accordion.Collapse eventKey="1">
            <div className="mt-2">
              {response?.citation_data.map((data, index) => (
                <div className="mb-2" key={index}>
                  {data}
                </div>
              ))}
            </div>
          </Accordion.Collapse>
          <hr className="mt-3 mb-3" />
          <CustomToggle eventKey="2">
            <span className="cursor-pointer">Referenced Files</span>
          </CustomToggle>
          <Accordion.Collapse eventKey="2">
            <div>
              {response?.metadata.map((file, index) => (
                <div key={index} className="mb-6">
                  <a
                    href={`https://docs.google.com/gview?url=https://d3u2s6c6uj6idz.cloudfront.net/knowledge-base/documents/${file.name}&embedded=true`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {file.name}
                  </a>
                </div>
              ))}
            </div>
          </Accordion.Collapse>
        </Accordion>
      </div>
    </Container>
  );
};

const AgentAssist = ({ contactSet }) => {
  const [isQueryDropDownOpened, setIsQueryDropDownOpened] = useState(false);

  const [currentContact, setCurrentContact] = useState(null);
  const [agentQueryInput, setAgentQueryInput] = useState("");
  // const [chatUsers, setChatUsers] = useState([]);
  const [submittedFeedBackId, setSubmittedFeedBackId] = useState({});
  const [agent, setAgent] = useState({
    agentLdap: null,
    agentName: null,
    channelName: null,
    sessionId: null,
  });

  const { selectContact, userSession, loading } = useAppConfig();

  const {
    fetchRagResponse,
    chatHistory,
    isServiceAvailable,
    rollingText,
    submitFeedback,
    rejectedQueryList,
    agentAssistApiError,
    manualRejectedQueryRequest,
    chatUsers,
    aiChatLoading,
  } = useAgentAssistApi(contactSet);

  console.log("[chatHistory]", chatHistory);
  console.log("[agent rejectedQueryList]", rejectedQueryList);

  useEffect(() => {
    console.log("[submittedFeedBackId]", submittedFeedBackId);
    if (Object.keys(submittedFeedBackId).length > 0) {
      window.localStorage.setItem(
        "SUBMITTED_FEEDBACK_ID",
        JSON.stringify(submittedFeedBackId)
      );
    }
  }, [submittedFeedBackId]);

  useEffect(() => {
    const feedback = JSON.parse(
      window.localStorage.getItem("SUBMITTED_FEEDBACK_ID")
    );
    if (feedback) {
      setSubmittedFeedBackId(feedback);
    }
  }, []);

  useEffect(() => {
    let channelName = "";
    window.connect.agent(function (agent) {
      const agentDetails = agent.getChannelConcurrency();
      Object.keys(agentDetails).forEach((el) => {
        if (agentDetails[el]) {
          channelName = el === "VOICE" ? "IVR" : "CHAT";
        }
      });
      const uniqueID = generateUniqueID(
        agent._getData().configuration.username,
        agent._getData().configuration.name,
        "agent"
      );
      setAgent({
        agentLdap: agent._getData().configuration.username,
        agentName: agent._getData().configuration.name,
        channelName: channelName,
        sessionId: uniqueID,
      });
    });
  }, []);

  // useEffect(() => {
  //   console.log("[contactSet]", contactSet);
  //   // if (agent.sessionId) {
  //   //   setChatUsers((prevArray) => [...prevArray, agent.sessionId]);
  //   // }
  //   const newContact = [];
  //   contactSet.forEach((contact) => {
  //     newContact.push(contact.contactId);
  //   });
  //   if (agent.sessionId) {
  //     console.log("[newContact]", newContact);
  //     setChatUsers([agent.sessionId, ...newContact]);
  //   }
  // }, [agent, contactSet]);

  useEffect(() => {
    if (
      userSession?.content &&
      userSession?.content !== "" &&
      userSession?.contactId !== ""
    ) {
      if (
        !userSession?.content?.includes("Device Type") &&
        !userSession?.content?.includes("OS") &&
        !userSession?.content?.includes("BROWSER") &&
        !userSession?.content?.includes("Chat Summary Details")
      ) {
        fetchRagResponse({
          chatId: userSession?.contactId,
          content: userSession?.content,
          contactId: userSession?.contactId,
          userName: userSession.displayName,
          is_manual: false,
          channelName: agent.channelName,
        });
      }
    }
  }, [userSession]);

  useEffect(() => {
    if (contactSet.size > 0) {
      contactSet.forEach(function (val) {
        if (selectContact && selectContact === val.contactId) {
          setCurrentContact(val);
        }
      });
    } else {
      setCurrentContact("");
    }
  });

  const requestQuery = (query) => {
    console.log("[manualRejectedQueryRequest]", query);
    setIsQueryDropDownOpened(false);
    manualRejectedQueryRequest(query);
  };

  const rejectedUserQueryList = useMemo(() => {
    console.log("[query]", rejectedQueryList, selectContact);
    return rejectedQueryList[selectContact];
  }, [rejectedQueryList, selectContact]);

  console.log("[rollingText]", rollingText);

  return (
    <div className="w-100 bg-gray-500 canned-msg-container-rag">
      <div className="heading p-1 container-title fs-5">Agent Assist</div>
      <div className="content fs-14">
        <div className="agent-query-section m-1 d-flex position-relative">
          <div className="position-relative me-1">
            <Dropdown>
              <Dropdown.Toggle
                variant="secondary"
                id="dropdown-basic"
                className="btn-sm"
              >
                {rejectedUserQueryList && rejectedUserQueryList?.length > 0 && (
                  <Badge
                    className="position-absolute rounded-circle bg-danger bg-opacity-75 width d-flex justify-content-center align-items-center"
                    style={{
                      left: "14px",
                      top: "-10px",
                      width: "24px",
                      height: "24px",
                    }}
                    bg="secondary"
                  >
                    {rejectedUserQueryList.length}
                  </Badge>
                )}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.ItemText>Rejected Queries</Dropdown.ItemText>
                <Dropdown.Divider />
                {rejectedUserQueryList && rejectedUserQueryList.length <= 0 ? (
                  <Dropdown.ItemText>No Query Found</Dropdown.ItemText>
                ) : (
                  rejectedUserQueryList?.map((rejectedQuery, index) => {
                    return (
                      <Dropdown.Item
                        key={index}
                        onClick={() => requestQuery(rejectedQuery)}
                      >
                        <strong>Ask </strong>
                        {rejectedQuery.query}
                      </Dropdown.Item>
                    );
                  })
                )}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div className="agent-query-input input-group-sm w-100">
            <input
              spellCheck="true"
              autoFocus={true}
              placeholder="Enter your query"
              value={agentQueryInput}
              onChange={(e) => setAgentQueryInput(e.target.value)}
              type="text"
              className="form-control"
              // onClick={()=>validateSendMsg()}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  fetchRagResponse({
                    chatId:
                      chatUsers.length > 1 ? selectContact : agent.sessionId,
                    content: agentQueryInput,
                    contactId: agent.sessionId,
                    userName: currentContact?.fName || agent.agentName,
                    is_manual: true,
                    channelName: agent.channelName,
                  });
                  setAgentQueryInput("");
                }
              }}
            />
          </div>
        </div>
        <div className="response-section mt-2 fc-light-black overflow-auto">
          {agentAssistApiError && (
            <div className="card custom-card p-3 text-center rounded-0 mx-1 my-2">
              <p className="text-danger m-0">
                Service is down. Please reach out to support team.
              </p>
            </div>
          )}
          {!isServiceAvailable && (
            <div className="card custom-card p-3 text-center rounded-0 mx-1 my-2">
              <p className="text-danger m-0">
                Service is Temporarily Unavailable
              </p>
            </div>
          )}

          {chatUsers.map((user, index) => {
            let displayClass = "";
            if (contactSet.size <= 0) {
              displayClass = "";
            } else if (currentContact?.contactId !== user) {
              displayClass = "d-none";
            }
            return (
              <>
                <div
                  key={index}
                  className={`chat-history-wrapper ${displayClass}`}
                >
                  {aiChatLoading[user] && (
                    <div className="loader-container mb-2">
                      <div className="loader"></div>
                    </div>
                  )}
                  {rollingText?.[user] &&
                    Object.keys(rollingText?.[user]).map((content, index) => {
                      return (
                        <Container
                          fluid
                          className={`contact-details mb-2 mt-2 px-1`}
                          key={index}
                        >
                          <div
                            className="card custom-card p-3 rounded-0"
                            style={{ fontSize: "12px" }}
                          >
                            <div>
                              <i className="fa-regular fa-user m-0"></i>
                              <span className="ms-2">
                                {rollingText?.[user][content].name} said:
                              </span>
                              <p className="fw-bold mb-0 mt-1">{`"${rollingText?.[user][content].query}"`}</p>
                            </div>
                            <hr className="mt-3 mb-3" />
                            <strong className="cursor-pointer">Response</strong>
                            <p>{rollingText?.[user][content]?.answer}</p>
                          </div>
                        </Container>
                      );
                    })}
                  {chatHistory?.[user]?.map((response, index) => {
                    return (
                      <ResponseSection
                        response={response}
                        key={index}
                        user={user}
                        setSubmittedFeedBackId={setSubmittedFeedBackId}
                        submittedFeedBackId={submittedFeedBackId}
                        submitFeedback={submitFeedback}
                      />
                    );
                  })}
                </div>
              </>
            );
          })}
          <Container fluid className={`contact-details mb-2 mt-2 px-1`}>
            <div className="card custom-card p-3 rounded-0">
              <div className="d-flex align-items-center mb-4">
                <i className="fa-regular fa-star"></i>
                <h5 className="fs-6 d-inline fw-bold mb-0 ms-2">
                  Agent Assist
                </h5>
              </div>
              <div className="lh-sm" style={{ fontSize: "14px" }}>
                <p className="fw-bold mb-2">
                  Hello I am Agent Assist, your AI assistant!
                </p>
                <p className="">
                  As I listen to the conversation I will provide suggestions.
                </p>
              </div>
            </div>
          </Container>
        </div>
      </div>
    </div>
  );
};

export default AgentAssist;
